/*
This source is part of the Akeria  and is
copyrighted by Uniphore system software limited.

All rights reserved.  No part of this work may be reproduced, stored in a
retrieval system, adopted or transmitted in any form or by any means,
electronic, mechanical, photographic, graphic, optic recording or otherwise,
translated in any language or computer language, without the prior written
permission of  Uniphore system software limited.

Uniphore system software limited.
Vaishnavi Silicon Terrace, B- Block, 
3rd & 4th floor, Hosur Rd, 
Adugodi, Bengaluru, Karnataka 560095

India

Copyright 2019 Uniphore system software limited.

Modification History

Date          Version               Author                           Description
----------   -----------     --------------- ----------------        ------------------------
01 07 2018    1              Professional service Initial version     
01-11-2019   1.1             Gokulakannan                             Setting Page with full functionalites like tackback and speech recognization

*/

import { Component, OnInit } from '@angular/core';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { Platform, NavController, MenuController } from '@ionic/angular';

@Component({
  selector: 'app-setting',
  templateUrl: './setting.page.html',
  styleUrls: ['./setting.page.scss'],
})
export class SettingPage implements OnInit {

  headingtitle: any;
  langcontext: any;
  Role: any;
  constructor(public navctrl: NavController,public menuCtrl: MenuController, public platform: Platform,public cmndecl: CommonDeclarationService, public cmndef: CommonDefinitionService) {    
    if (this.cmndecl.LanguageJson) {
      this.langcontext = this.cmndecl.LanguageJson.pages[0]['settings'];
    } else {
      this.cmndecl.LanguageJson = JSON.parse(localStorage.languageJson);
      this.langcontext = this.cmndecl.LanguageJson['pages'][0].settings;
    }
    console.log(this.cmndecl.speechrate)
    this.Role = localStorage.role;
    this.headingtitle = this.langcontext.heading.text;
  }

  ngOnInit() {
  }

  ionViewWillEnter () {
    this.menuCtrl.swipeEnable(false);
  }

  voice(){
    localStorage.voiceenable = this.cmndecl.enablevoice
  }

  tackback(){
    localStorage.tackbackenable = this.cmndecl.enabletackback;
  }

  speechrate(){
    localStorage.speechrate = this.cmndecl.speechrate;
    this.cmndecl.Speacksetup();
  }


}
